export default {
  // 智慧农业4.0
  Agriculture: '/productmanage/datascreen/statistics/detail?pageId=d1',
  // 采收计划
  GetHarvestPlanList: '/productmanage/datascreen/statistics/getHarvestPlanList',
  // 生产数据
  GetPlantingInfoStatistic: '/apiInterface/trace/hainanrunda/massifinfostatistic/getPlantingInfoStatistic',
  // 大棚
  GetMassIfInfoStatistic: '/apiInterface/trace/hainanrunda/massifinfostatistic/getMassIfInfoStatistic',
  // 种植批次
  GetLastestPickingBatchList: '/trace/hainanrunda/massifinfostatistic/getLastestPickingBatchList',
  // 智慧种植
  Smartplanting: '/productmanage/datascreen/statistics/detail?pageId=d2',
  // 智慧追溯
  Trace: '/code/scanstatistics/getScanStatistics?organizationId=86ff1c47b5204e88918cb89bbd739f12',
  // 扶贫
  Helper: '/productmanage/datascreen/statistics/detail?pageId=d4',
  // 销售中心
  salesDataCenter: '/productmanage/datascreen/statistics/detail?pageId=d3'
}



// WEBPACK FOOTER //
// ./src/data/apiUrl/modules/dataAnalysis/index.js